import { Card } from '@/components/ui/card'
import { formatCurrency } from '@/lib/format'
import type { ProjectInvoice } from '@/types'

interface InvoiceSummaryCardProps {
  invoice: ProjectInvoice
}

const TYPE_LABEL: Record<ProjectInvoice['type'], string> = {
  deposit: 'Acompte',
  final: 'Finale',
  standalone: 'Standalone',
  credit_note: 'Note de crédit',
}

/**
 * Compact recap shown under the InvoiceSelectField once an invoice is picked.
 * Same surface for Mode A and Mode B. SOLY-CN-001 mini-scope 04.
 */
export function InvoiceSummaryCard({ invoice }: InvoiceSummaryCardProps) {
  return (
    <Card
      data-testid="credit-note-invoice-summary-card"
      className="p-3 space-y-1 bg-muted/30 text-sm"
    >
      <div className="flex items-center gap-2">
        <span className="font-medium font-mono">{invoice.number}</span>
        <span className="text-muted-foreground">·</span>
        <span>{TYPE_LABEL[invoice.type]}</span>
        <span className="text-muted-foreground">·</span>
        <span>{new Date(invoice.invoiceDate).toLocaleDateString('fr-BE')}</span>
      </div>
      <div className="text-muted-foreground">
        TTC <span className="font-medium text-foreground">{formatCurrency(invoice.amountWithTax)}</span>
      </div>
    </Card>
  )
}
